import { ApplicationSettings, EmployeePortalSettings } from "../../../DTOs";
import { basicValidation } from "../basicValidation";
import { miscFieldValidation } from "./miscFieldValidation";

export const applicationSettingsValidation = {
    applicationSettings: {
        applicationSettings: (value: ApplicationSettings) =>
        {
            return value 
                && applicationSettingsValidation.applicationSettings.applicationSettingsObject(value)
                && applicationSettingsValidation.applicationSettings.applicationSettingsEmployeePortalSettings(value)
                && applicationSettingsValidation.applicationSettings.applicationSettingsEmployeePortalSettingsEnabled(value)
                && applicationSettingsValidation.applicationSettings.applicationSettingsEmployeePortalSettingsResetTimeStamp(value)
                && applicationSettingsValidation.applicationSettings.applicationSettingsEmployeePortalSettingsAuthentication(value)
                && applicationSettingsValidation.applicationSettings.applicationSettingsEmployeePortalSettingsMagicLink(value)
                && applicationSettingsValidation.applicationSettings.applicationSettingsEmployeePortalSettingsMagicLinkEnabled(value)
                && applicationSettingsValidation.applicationSettings.applicationSettingsEmployeePortalSettingsMagicLinkValidDomains(value)
                && applicationSettingsValidation.applicationSettings.applicationSettingsEmployeePortalSettingsPublicKey(value)
                && applicationSettingsValidation.applicationSettings.applicationSettingsEmployeePortalSettingsPublicKeyEnabled(value)
                && applicationSettingsValidation.applicationSettings.applicationSettingsEmployeePortalSettingsPublicKeyAccessKey(value);
        },
        applicationSettingsObject: (value: ApplicationSettings) =>
        {
            return !!value;
        },
        applicationSettingsEmployeePortalSettings: (value: ApplicationSettings) =>
        {
            return !!value?.employeePortalSettings;
        },
        applicationSettingsEmployeePortalSettingsEnabled: (value: ApplicationSettings) =>
        {
            return basicValidation.validateBoolean(value?.employeePortalSettings?.enabled as any);
        },
        applicationSettingsEmployeePortalSettingsResetTimeStamp: (value: ApplicationSettings) =>
        {
            const resetTimeStamp = value?.employeePortalSettings?.resetTimeStamp;
            return resetTimeStamp instanceof Date && basicValidation.date(resetTimeStamp);
        },
        applicationSettingsEmployeePortalSettingsAuthentication: (value: ApplicationSettings) =>
        {
            return !!value?.employeePortalSettings?.authentication;
        },
        applicationSettingsEmployeePortalSettingsMagicLink: (value: ApplicationSettings) =>
        {
            return !!value?.employeePortalSettings?.authentication?.magicLink;
        },
        applicationSettingsEmployeePortalSettingsMagicLinkEnabled: (value: ApplicationSettings) =>
        {
            return basicValidation.validateBoolean(value?.employeePortalSettings?.authentication?.magicLink?.enabled as any);
        },
        applicationSettingsEmployeePortalSettingsMagicLinkValidDomains: (value: ApplicationSettings) =>
        {
            const validDomains = value?.employeePortalSettings?.authentication?.magicLink?.validDomains;
            return Array.isArray(validDomains)
                && validDomains.every((d: any) => typeof d === 'string')
                && validDomains.every((d: string) => basicValidation.isValidEmailDomain(d))
                && basicValidation.arrayStringsAreUnique(validDomains);
        },
        applicationSettingsEmployeePortalSettingsPublicKey: (value: ApplicationSettings) =>
        {
            return !!value?.employeePortalSettings?.authentication?.publicKey;
        },
        applicationSettingsEmployeePortalSettingsPublicKeyEnabled: (value: ApplicationSettings) =>
        {
            return basicValidation.validateBoolean(value?.employeePortalSettings?.authentication?.publicKey?.enabled as any);
        },
        applicationSettingsEmployeePortalSettingsPublicKeyAccessKey: (value: ApplicationSettings) =>
        {
            const accessKey = value?.employeePortalSettings?.authentication?.publicKey?.accessKey;
            return typeof accessKey === 'string'
                && (accessKey === '' || new RegExp('^[a-z0-9]{32}$').test(accessKey));
        },
        employeePortalSettings: (value: EmployeePortalSettings) =>
        {
            return applicationSettingsValidation.applicationSettings.applicationSettings({ employeePortalSettings: value });
        }
    }
}
